export default __webpack_public_path__ + "static/media/GroupbottomPink.86a1d016.png";